import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./App.css";

import * as Sentry from "@sentry/browser";

import { Provider } from "react-redux";

import App from "./App";
import { DSN } from "./config.js";
import { FPAlertProvider } from "./AlertProvider";
import { store } from "./store";

Sentry.init({ dsn: DSN });

const Root = () => (
  <Provider store={store}>
    <FPAlertProvider>
      <App />
    </FPAlertProvider>
  </Provider>
);

ReactDOM.render(<Root />, document.getElementById("root"));
